var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 .1a.9.9 0 01.9.9v.999L17 2a3 3 0 013 3v14a3 3 0 01-3 3H3a3 3 0 01-3-3V5a3 3 0 013-3l2.1-.001V1a.9.9 0 01.787-.893L6 .1a.9.9 0 01.9.9v.999h6.2V1a.9.9 0 01.787-.893zm4 9.799H2V19a1 1 0 001 1h14a1 1 0 001-1V9.899zm-12.9-5.9L3 4a1 1 0 00-1 1v3.099h16V5a1 1 0 00-1-1l-2.1-.001V5a.9.9 0 01-.787.893L14 5.9a.9.9 0 01-.9-.9V3.999H6.9V5a.9.9 0 01-.787.893L6 5.9a.9.9 0 01-.9-.9V3.999z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.42ee79933f77bb56ad87ac05d32bfa1b.svg";
export { ForwardRef as ReactComponent };